import React from 'react';
import { Page } from '/imports/ui/Page';
import { DevToolTestSms } from '/imports/ui/DevToolTestSms';
import { DevToolGoatbots } from '/imports/ui/DevToolGoatbots';
import { DevToolMtgoGoldfish } from '/imports/ui/DevToolMtgoGoldfish';
// Obsolete: superseded by DevToolIngestImages (the client-based image pipeline).
// import { DevToolImages } from '/imports/ui/DevToolImages';
import { DevToolIngestImages } from '/imports/ui/DevToolIngestImages';
import { DevToolMfaOtp } from '/imports/ui/DevToolMfaOtp';
import { DevToolChecksum } from '/imports/ui/DevToolChecksum';
import { DevToolRegistry } from '/imports/ui/DevToolRegistry';

const DevToolsPageStyled = (props: React.ComponentProps<typeof Page>) => (
  <Page
    {...props}
    className={[
      props.className ?? '',
      'box-border px-12 pt-6',
      '[&_section]:mb-4 [&_section]:rounded-card [&_section]:border [&_section]:border-grey-6 [&_section]:p-4',
    ].join(' ')}
  />
);

export const DevToolsPage = () => {
  return (
    <DevToolsPageStyled>
      <h1>Dev Tools</h1>
      <DevToolTestSms />
      <DevToolGoatbots />
      <DevToolMtgoGoldfish />
      {/* <DevToolImages /> */}
      <DevToolIngestImages />
      <DevToolMfaOtp />
      <DevToolChecksum />
      <DevToolRegistry />
    </DevToolsPageStyled>
  );
};
